import { createContext, useContext } from 'react';

/** @type {React.Context<any>} */
export const OnboardingContext = createContext(null);

export function useOnboardingContext() {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    throw new Error('useOnboardingContext must be used within OnboardingProvider');
  }
  return ctx;
}
